export default {"src":"/_next/static/media/icon2.365d35a7.svg","height":512,"width":512};